module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp13_8003.9cb1b8ce.png";